import React, { Component } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

export default class TooltippedCel extends Component {
	constructor(props) {
		super(props);
		// debugger
		this.state = { id: `Tooltip-${parseInt(Math.random() * 1000000)}` };
	}

	render = () => (
		<span id={this.state.id} className="text-center">
			<div dangerouslySetInnerHTML={{ __html: this.props.text ? this.props.text : "" }} />
			<UncontrolledTooltip placement={`${this.props.placement||'auto'}`} target={this.state.id}>
				<div dangerouslySetInnerHTML={{ __html: this.props.text ? this.props.text : "" }} />
			</UncontrolledTooltip>
		</span>
	);
}


// WEBPACK FOOTER //
// ./src/Componente/Common/TooltippedCel.jsx